/** Shopify CDN: Minification failed

Line 61:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 62:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 94:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 104:11 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 113:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 114:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 116:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 133:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 134:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 29 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 46:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 47:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 69:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 79:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 89:11 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 101:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 118:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 119:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 29 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 32:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 54:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 64:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 74:11 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 83:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 86:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 103:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 104:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 29 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 17:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 39:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 49:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 59:11 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 69:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 71:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 88:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 89:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 29 more hidden warnings

**/
class DropdownMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: 'shopify-section-header',
      background: '.header-background',
      topMenuItem: '.header__menu-item--top',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.list-menu-dropdown > .list-menu'
    };
    this.timeout;

    this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;

    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.resetBackground();
    this.animateMenu();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);

    this.header = this.header || document.getElementById(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper)
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  addClasses() {
    const isTopLevel = this.querySelector(this.selectors.topMenuItem);

    let delay = 0;
    if (isTopLevel && !this.isHover()) {
      delay = 150;

      if (this.closest('.header--top-center') || this.closest('.header--top-left')) {
        delay = 200;
      }
    }
    this.timeout = setTimeout(() => {
      if (this.isHover()) {
        this.classList.add(this.classes.active);
      }
    }, delay);

    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);

    menus.forEach((menu) => {
      let found = false;
      const childMenus = menu.querySelectorAll('dropdown-menu');
      childMenus.forEach((element) => {
        if (element === this) {
          found = true;
          return;
        }
      });

      if (!found) menu.reset();
    });
  }

  isHover() {
    return this.header.classList.contains(this.classes.hover);
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate =  this.querySelector(this.selectors.childAnimate);
    if (childAnimate) childAnimate.classList.remove(this.classes.animate);

    clearTimeout(this.timeout);
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  animateMenu() {
    const childAnimate =  this.querySelector(this.selectors.childAnimate);
    if (childAnimate) {
      setTimeout(() => {
        childAnimate.classList.add(this.classes.animate);
      }, 150);
    }
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('dropdown-menu', DropdownMenu);

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: 'shopify-section-header',
      background: '.header-background',
      dropdown: '.list-menu-dropdown',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.mega-menu__item, .mega-menu__promo'
    };
    this.timeout = [];

    this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;
    
    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.showSublist();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);
    
    this.header = this.header || document.getElementById(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper)
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  showSublist() {
    const dropdown = this.querySelector(this.selectors.dropdown);
    const background = this.header.querySelector(this.selectors.background);
    background.style.height = this.header.clientHeight + dropdown.clientHeight + 'px';
    background.classList.add(this.classes.active);
  }

  addClasses() {
    this.classList.add(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    const delay = childAnimate.length > 5 ? 75 : 150;
    childAnimate.forEach((element, index) => {
      const timeout = setTimeout(() => {
        element.classList.add(this.classes.animate);
      }, (delay * index) + 100);
      
      this.timeout.push(timeout);
    });
    
    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);
    menus.forEach((menu) => {
      menu.reset();
    });
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    childAnimate.forEach((element) => {
      element.classList.remove(this.classes.animate);
    });
    this.timeout.forEach((timeout) => {
      clearTimeout(timeout);
    });
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('mega-menu', MegaMenu);
